import request from './req'
export default {
  baseURL: process.env.BASE_API_URL,
  crmUrl: process.env.crmUrl,
  userUrl: process.env.userUrl,
  preview: process.env.preview,
  portalUrl: process.env.portalUrl,
  socketUrl: process.env.socketUrl,
  uploadUrl: process.env.uploadUrl,
  // signOutURL: process.env.SIGN_OUT_URL,
  mapKey: 'D3nZMKXihwABMSDepuVIu0ry4QnWzpCt',
  get: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'get',
      params: p,
      rules: rule
    })
  },
  getCode: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'get',
      params: p,
      rules: rule,
      responseType: "arraybuffer",
    })
  },
  getResource: function(url, p, rule) {
    return request({
      // 'resource/'+
      url: this.baseURL + url,
      method: 'get',
      params: p,
      responseType: "arraybuffer",
      rules: rule
    })
  },
  getUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'get',
      params: p,
      rules: rule
    })
  },

  query: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },
  queryUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },

  post: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },
  postPortal: function(url, p, rule) {
    return request({
      url: (this?this.portalUrl:process.env.portalUrl) + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },
  postUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },


  postp: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      params: p,
      rules: rule
    })
  },
  postpUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      params: p,
      rules: rule
    })
  },


  postf: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: da1,
      rules: rule
    })
  },
  postfUser: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: da1,
      rules: rule
    })
  },

  // variable
  search: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'get',
      params: p,
      rules: rule
    })
  },
  searchUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'get',
      params: p,
      rules: rule
    })
  },
  // {}


  add: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },
  addUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: p,
      rules: rule
    })
  },
  // {}


  addf: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: da1,
      rules: rule
    })
  },
  addfUser: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'post',
      data: da1,
      rules: rule
    })
  },
  // {}

  update: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'put',
      data: p,
      rules: rule
    })
  },
  updateUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'put',
      data: p,
      rules: rule
    })
  },


  updatep: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'put',
      params: p,
      rules: rule
    })
  },
  updatepUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'put',
      params: p,
      rules: rule
    })
  },


  // {}
  updatef: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'put',
      data: da1,
      rules: rule
    })
  },


  updatefUser: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'put',
      data: da1,
      rules: rule
    })
  },
  // variable
  // variable


  del: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'delete',
      data: p,
      rules: rule
    })
  },
  delUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'delete',
      data: p,
      rules: rule
    })
  },


  delf: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'delete',
      data: da1,
      rules: rule
    })
  },
  delfUser: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.baseURL + url,
      method: 'delete',
      data: da1,
      rules: rule
    })
  },



  delp: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'delete',
      params: p,
      rules: rule
    })
  },
  delpUser: function(url, p, rule) {
    return request({
      url: this.baseURL + url,
      method: 'delete',
      params: p,
      rules: rule
    })
  },

  // 上传
  uploadf: function(url, p, rule) {
    const da1 = new FormData()
    for (var key in p) {
      da1.append(key, p[key])
    }
    return request({
      url: this.uploadUrl + url,
      method: 'post',
      data: da1,
      rules: rule
    })
  },
  
}



// WEBPACK FOOTER //
// ./src/js/base.js